import ExlyTable from "common/Components/ExlyTable";
import React from "react";
import columnStyle from "./Components/Columns/Columns.module.css";
import ExlyLoader from "ui/modules/ExlyLoader";
import useAppLayoutControl from "hooks/useAppLayoutControl";
import { AddVariation } from "./Components/AddVariation";
import {
  CREATE_VARIATION_CTA_TEXT,
  empty_state_props,
} from "features/OfferingVariations/OfferingVariations.constants";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import ExlyDeleteModal from "common/Components/ExlyDeleteModal/ExlyDeleteModal";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { useIsDesktop } from "@my-scoot/exly-react-component-lib";
import { OfferingVariationsHeaderActions } from "./OfferingVariationsHeaderActions";
import { SectionHeading } from "features/AdminPanel/modules/SectionHeading/SectionHeading";
import {
  MANAGE_OFFERINGS_ROUTE_IDS,
  MANAGE_OFFERINGS_ROUTE_KEYS,
} from "features/ManageOfferings/constants/ManageOfferings.urlPaths";
import { useOfferingVariationListStore } from "./store/useOfferingVariationList.store";
import { colomnKeys } from "./OfferingVariationsList.constants";
import { useOfferingVariations } from "features/OfferingVariations/utils/hooks/useOfferingVariations";
import { useOfferingKycEnabled } from "features/ManageOfferings/modules/PerTierKyc/useOfferingKycEnabled";
import { VariationKycContainer } from "features/ManageOfferings/modules/PerTierKyc/VariationKycContainer";

export const OfferingVariationsList = withComponentLibraryTheme((props) => {
  const isDesktop = useIsDesktop();

  useAppLayoutControl({ values: { showBottomNav: false } });

  const offeringUuid = useOfferingVariationListStore(
    (state) => state.offeringUuid
  );
  const setShowAddVariation = useOfferingVariationListStore(
    (state) => state.setShowAddVariation
  );
  const isEnabled = useOfferingVariationListStore((state) => state.isEnabled);
  const setShowDeleteModal = useOfferingVariationListStore(
    (state) => state.setShowDeleteModal
  );
  const setSelectedVariation = useOfferingVariationListStore(
    (state) => state.setSelectedVariation
  );
  const processing = useOfferingVariationListStore((state) => state.processing);
  const showDeleteModal = useOfferingVariationListStore(
    (state) => state.showDeleteModal
  );
  const columnConfig = useOfferingVariationListStore(
    (state) => state.columnConfig
  );
  const showKycColumn = useOfferingVariationListStore(
    (state) => state.showKycColumn
  );
  const setShowKycColumn = useOfferingVariationListStore(
    (state) => state.setShowKycColumn
  );
  // Single page-level KYC check (same as memberships table) — never inside
  // row-level hooks, so the settings APIs fire once per page, not per row.
  const { isKycEnabled } = useOfferingKycEnabled({
    listingUuid: offeringUuid,
  });
  React.useEffect(() => {
    setShowKycColumn(isKycEnabled);
  }, [isKycEnabled, setShowKycColumn]);
  const { provider } = useOfferingVariations({ offeringUuid });
  const { deleteVariation, handleEditVariation, closeModal, footerProps } =
    provider;

  return (
    <>
      {isDesktop && (
        <SectionHeading
          heading={
            isDesktop ? `Create and Manage Variations` : "Manage Variations"
          }
          showBackIcon
          backUrl={`${
            MANAGE_OFFERINGS_ROUTE_IDS[
              MANAGE_OFFERINGS_ROUTE_KEYS.SUBSCRIPTIONS
            ]
          }/${offeringUuid}`}
          headerRight={
            isDesktop ? (
              <OfferingVariationsHeaderActions
                showCreateButton
                createDisabled={!isEnabled}
                onCreate={() => setShowAddVariation(true)}
                createLabel={CREATE_VARIATION_CTA_TEXT}
              />
            ) : (
              <OfferingVariationsHeaderActions />
            )
          }
        />
      )}
      {processing ? (
        <ExlyLoader />
      ) : (
        <div className="md:tw-pb-6 md:tw-mx-12">
          <div className={isDesktop ? `tw-pt-3 tw-pb-3` : "p-3"}>
            <ExlyTable
              ra_props={props}
              columnConfig={columnConfig.filter(
                (column) =>
                  showKycColumn ||
                  column.headerName !== colomnKeys.kyc.label
              )}
              primaryKey="id"
              customPrimaryAction={{
                label: "Edit Variation",
                onClick: (row) => handleEditVariation(row),
              }}
              hasMobileFooter
              noExportButton={true}
              footerProps={footerProps}
              renderSecondaryAction={(record) => (
                <DeleteIcon
                  onClick={() => {
                    if (!isEnabled) return;
                    setSelectedVariation(record);
                    setShowDeleteModal(true);
                  }}
                  className={`${columnStyle.deleteIcon}`}
                />
              )}
              borderedFields={true}
              fieldsAlignment="space-between"
              recordFooterVariant="secondary"
              layoutProps={{
                exlyTableRootClass: !isEnabled ? "opacity-50" : "",
                showFixedBars: true,
                noShadow: true,
                paddingBottom: "32px",
                paddingMobile: "10px 0",
                noMobileBoxShadow: true,
              }}
              {...empty_state_props}
            />
          </div>
          <ExlyDeleteModal
            onClose={closeModal}
            onDelete={deleteVariation}
            open={showDeleteModal}
            title="Confirm Delete"
            description="Are you sure you want to delete the selected offering variation?"
          />

          <AddVariation />
          <VariationKycContainer />
        </div>
      )}
    </>
  );
});
